import classNames from "classnames";
import React from "react";
import type { BsPrefixProps, BsPrefixRefForwardingComponent } from "react-bootstrap/esm/helpers";
import { useBootstrapBreakpoints, useBootstrapMinBreakpoint, useBootstrapPrefix } from "./ThemeProvider";
import type { ResponsiveUtilityValue } from "./createUtilityClasses";
import createUtilityClassName from "./createUtilityClasses";
import type { AlignItems, ColumnSize, JustifyContent } from "./types";

export interface GridProps extends BsPrefixProps, React.HTMLAttributes<HTMLElement> {
	cols?: ResponsiveUtilityValue<ColumnSize>;
	gap?: ResponsiveUtilityValue<ColumnSize>;

	alignItems?: ResponsiveUtilityValue<AlignItems>;
	justifyContent?: ResponsiveUtilityValue<JustifyContent>;
}

export const Grid: BsPrefixRefForwardingComponent<"div", GridProps> = React.forwardRef<HTMLElement, GridProps>(
	({ as: Component = "div", bsPrefix, className, cols, gap, alignItems, justifyContent, ...props }, ref) => {
		bsPrefix = useBootstrapPrefix(bsPrefix, "grid");
		const breakpoints = useBootstrapBreakpoints();
		const minBreakpoint = useBootstrapMinBreakpoint();

		return (
			<Component
				ref={ref}
				className={classNames(
					className,
					bsPrefix,
					...createUtilityClassName(
						{
							"grid-cols": cols,
							gap,
							"align-items": alignItems,
							"justify-content": justifyContent,
						},
						breakpoints,
						minBreakpoint,
					),
				)}
				{...props}
			/>
		);
	},
);
